import React from 'react';

import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Alert from '@material-ui/lab/Alert';
import TextField from '@base/Inputs/Text'

import { numberMask } from '@helpers/MaskHelper'

const useStyles = makeStyles(
	(theme) => (
		{
			wrapper: {
				padding: theme.spacing(2)
			},
			title: {
				color : "#333",
				fontSize: 24,
			},
            formControl: {
                margin: theme.spacing(2, 0),
                width: '100%',
            }
		}
	)
);

export const FormularioContagem = (props) => {

    const meuEstilo = useStyles();

	return (
        <>
            <Paper className={meuEstilo.wrapper} elevation={0} spacing={2}>

      

              <Grid alignItems="center" container spacing={2}>



                          
            <Grid item sm={2} >
                  <TextField
                    disabled={true}
                    label="Número do Objeto Postal"
                    value={props.numeroObjetoPostal}    />
				        </Grid>
            {!props.recontagem &&
                <Grid item sm={2}>
                  <TextField
                      disabled={true}
                      label='Caixa'
                      value={props.caixa}
                  />
                </Grid>}

              </Grid>

              {props.recontagem &&
            <>
               
                <Grid alignItems="center" container spacing={2}>

                <Grid item sm={2}>
                  <TextField
                      disabled={true}
                      label='Número de Recontagens'
                      value={props.numeroRecontagens}
                  />
                </Grid>

                </Grid>
                <Grid alignItems="center" container spacing={2}>
                    <Grid item sm={12} >
                    <Alert severity="warning">{props.motivoRecontagem}</Alert>
                       
                    </Grid>
                </Grid>
            </>
            }

                <Grid alignItems="center" container spacing={2}>

                    <Grid item sm={2} >
                        <TextField
                            autoFocus
                            id="desRef"
                            required
                            label="DEs"
                            value={props.desContados}
                            onChange={(e) => {
                                props.handleDesContados(numberMask(e.target.value))
                            }}
                        />
                    </Grid>

                    <Grid item sm={2} >
                        <TextField
                            id="cartoesN1Ref"
                            required

                            label="Cartoẽs N1"
                            value={props.cartoesN1Contados}
                            onChange={(e) => {
                                props.handleCartoesN1Contados(numberMask(e.target.value))
                            }}
                            disabled={props.readonly}
                        />
                    </Grid>

                    <Grid item sm={2} >
                        <TextField
                            id="cartoesN2Ref"
                            required
                            label="Cartoẽs N2"
                            value={props.cartoesN2Contados}
                            onChange={(e) => {
                                props.handleCartoesN2Contados(numberMask(e.target.value))
                            }}
                            disabled={props.readonly}
                        />
                    </Grid>

                    <Grid item sm={2} >
                        <TextField
                            id="cartoesN3Ref"
                            required
                            label="Cartoẽs N3"
                            value={props.cartoesN3Contados}
                            onChange={(e) => {
                                props.handleCartoesN3Contados(e.target.value)
                            }}
                            disabled={props.readonly}
                        />
                    </Grid>
                </Grid>
                {props.recontagem &&
                    <Grid alignItems="center" container spacing={2}>
                        <Grid item sm={3}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.conteudoNaoPrevisto}
                                        value={props.conteudoNaoPrevisto}
                                        onChange={(e) => {
                                            props.handleConteudoNaoPrevisto(e.target.checked);
                                        }}
                                        color="primary"
                                    />
                                }
                                label="Outros Documentos"
                            />
                        </Grid>
                    </Grid>
                }



            </Paper>
            <br />
		</>
	);
}

export default FormularioContagem;
